import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { StoredMeasurement, StoredSpot } from '../../../types/Individualization'
import { getSpotRealSizesInMm } from '../../../helpers/getSpotRealSizesInMm'

type SpotRealSizeTextProps = {
    spot: StoredSpot
    measurement: StoredMeasurement | null
}

const SpotRealSizeText: React.FC<SpotRealSizeTextProps> = ({
    spot,
    measurement,
}) => {
    const { t } = useTranslation(['customizer'])

    const realSizes = useMemo(
        () => getSpotRealSizesInMm(spot, measurement),
        [spot, measurement]
    )

    if (!spot.show_real_size || !realSizes) {
        return null
    }

    return (
        <p className={'zr-mb-3'}>
            {t('real_size')}:{' '}
            {t('real_size_format', {
                width: realSizes.width,
                height: realSizes.height,
            })}
        </p>
    )
}

export default SpotRealSizeText
